import { ConcreteEncodable } from "./ConcreteEncodable";

import { DataProfileResponseImplEncoder } from "../../encoder/DataProfileResponseImplEncoder";

import * as CubiqTS from "../../index";
import { DataProfileResponse } from "../DataProfileResponse";

export class DataProfileResponseImpl extends ConcreteEncodable implements DataProfileResponse {
  public static enType: string = "com.bcdfx.model.DataProfileResponseImpl";

  /*FID=1*/
  public responseData: Array<CubiqTS.StandardReport> | null = null;
  /*FID=2*/
  public dataMask: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DataProfileResponseImplEncoder.Instance;
    this.setEncodableType(DataProfileResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DataProfileResponseImpl[" +
      "responseData=" +
      this.responseData +
      "dataMask=" +
      this.dataMask +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
